export default __webpack_public_path__ + "static/media/MISTRZ_ZWINNOSCI.c5384a9b.png";